<template>
	<div class="father-devlivery">
		<!--<mensajeria-checkout 
      v-if="service_selected" 
      :message="service_selected"
      @closeCheckoutDelivery="service_selected = $event"
      >
    </mensajeria-checkout>-->
    <DeliveryCheckout v-if="service_selected" :form="service_selected" @closeCheckout="service_selected = $event"></DeliveryCheckout>
		<div class="delivery-container" v-show="!service_selected && !status_view">
			<div class="new-all-container">
				<div class="new-header-container">
					<div class="first-info">
						<div class="logo-cuadro">
							<img v-bind:src="url_images + logo">
						</div>
						<div class="meta-data-license">
							<h4>{{ nombre }}</h4>
							<h5><i class="fas fa-map-marker-alt" v-bind:style="{color : color_licencia }"></i>Valledupar</h5>
						</div>
					</div>
					<div class="second-info">
						<div class="license-info-button" @click="openInfo()">
							<i class="fas fa-info"></i>
							<i class="fas fa-angle-up"></i>
						</div>
						<div class="license-search-button" @click="openSearch()">
							<i class="fas fa-search"></i>
							<i class="fas fa-angle-up"></i>
						</div>
					</div>
				</div>
				<div class="license-data-2" v-if="status_info">
					<h4><i class="fas fa-map-marker-alt"></i>{{ direccion }}</h4>
					<h4><i class="far fa-clock"></i>{{ horario }}</h4>
				</div>
				<div class="search-input" v-if="status_search">
					<i class="fas fa-search"></i>
					<input type="text" placeholder="Buscar restaurantes" @keyup="search()" id="buscar">	
				</div>
			</div>
			<div class="tittle-service">
				<h4>Servicios</h4>
			</div>
			<div class="services-container">
				<div class="single-service" v-for="(item, index) in servicios[0].products" @click="openCheckout(item)">
					<div class="father-icon-container">
						<div class="icon-container" v-bind:id="'icon_'+index" v-bind:style="{backgroundColor : color_licencia }">
							<img v-bind:src="url_images + item.galery_images[0]">
						</div>
					</div>
					<div class="service-description">
						<h4>{{ item.name }}</h4>
					</div>
				</div>
			</div>
			<div class="new-restaurant-container">
				<div class="header-rest-tittle">
					<h4>Restaurantes</h4>
					<h5 @click="openNewview()">Ver todos</h5>
				</div>
				<div class="collection-restaurant">
					<div class="restaurant-item" v-for="(item, index) in restaurantes" :key="index" @click="openDetail(item)" v-bind:id="'restaurant_'+index">
						<div class="item-image">
							<img v-bind:src="url_images + item.portada[0]">
						</div>
						<div class="item-description">
							<h5>{{ item.ciudad }}</h5>
							<h4>{{ item.name }}</h4>
							<h6><i class="fas fa-utensils"></i>{{ item.cooking_time }} min - <i class="fas fa-biking" v-bind:style="{color : color_licencia }"></i>${{ Intl.NumberFormat("de-DE").format(valor_domicilio) }}</h6>
						</div>
					</div>
				</div>
			</div>	
		</div>
		<div class="new-view-header" v-show="status_view">
			<div class="all-restaurant-header">
				<div class ="back-button-all" @click="closeNewView()">
					<i class="fas fa-angle-left"></i>
				</div>
				<div class="input-search-all">
					<i class="fas fa-search"></i>
					<input type="text" placeholder="Buscar restaurantes" id="buscar2" @keyup="search2()">
				</div>
			</div>
			<div class="all-restaurant-view">
				<div class="single-restaurant-view" v-for="(item, i) in restaurantes" :key="i" @click="openDetail(item)" v-bind:id="'view_'+i">
					<div class="restaurant-view-image">
						<img v-bind:src="url_images + item.portada[0]">
					</div>
					<div class="restaurant-view-description">
						<h4>{{ item.name }}</h4>
						<h5><i class="fas fa-map-marker-alt" v-bind:style="{color : color_licencia }"></i>{{ item.ciudad }}</h5>
						<h6><i class="fas fa-utensils" v-bind:style="{color : color_licencia }"></i>{{ item.cooking_time }} min - <i class="fas fa-biking" v-bind:style="{color : color_licencia }"></i>${{ Intl.NumberFormat("de-DE").format(valor_domicilio) }}</h6>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	*:focus{
		outline: none;
		box-shadow: none;
	}


	/*Css nueva vista de restaurantes*/

	.all-restaurant-header{
		width: 100%;
		height: auto;
		padding: 20px 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-bottom: 10px solid #F4F6FA;
	}	

	.back-button-all{
		width: 45px;
		height: 45px;
		background: #F4F6FA;
		border-radius: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}

	.input-search-all{
		width: 93%;
		padding: 12px 20px;
		margin: 0 auto;
		border-radius: 10px;
		background: #F4F6FA;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.input-search-all i{
		font-size: 15px;
		color: #A6AAB3;
	}

	.input-search-all input{
		width: 90%;
		margin-left: 10px;
		font-size: 14px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		background: transparent;
		border: none;
	}

	.all-restaurant-view{
		width: 100%;
		min-height: 90vh;
		background: #fff;
		padding: 15px;
	}

	.single-restaurant-view{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		background: #fff;
		padding: 15px 10px;
		border-bottom: 1px solid #ddd;
		margin-bottom: 10px;
	}

	.restaurant-view-image{
		width: 30%;
		height: 100px;
		border: 1px solid #ddd;
		overflow: hidden;
		border-radius: 10px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
	}

	@supports(object-fit: cover){
    .restaurant-view-image img{
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }

  .restaurant-view-description{
  	width: 70%;
  	display: block;
  	padding: 0px 10px;
  	text-align: left;
  }

  .restaurant-view-description h4{
  	font-size: 19px;
  	font-weight: 600;
  	font-family: 'Poppins', sans-serif;
  	margin-bottom: 4px;
  }

  .restaurant-view-description h5{
  	font-size: 16px;
  	font-weight: 500;
  	margin-bottom: 8px;
  	font-family: 'Poppins', sans-serif;
  }

  .restaurant-view-description h6{
  	font-size: 13px;
  	font-weight: 500;
  	font-family: 'Poppins', sans-serif;
  }

  .restaurant-view-description i{
  	margin-right: 5px;
  }

	/*Fin Css nueva vista de restaurantes*/



	/*Nuevo Css*/

	.item-description{
		width: 100%;
		display: block;
		padding: 10px 0px;
		text-align: left;
	}

	.item-description h4, h5, h6{
		margin-bottom: 0;
		font-family: 'Poppins', sans-serif;
	}

	.item-description h5, h6{
		font-weight: 400;
		color: #B0B0B0;
	}

	.item-description h5{
		font-size: 14px;
	}

	.item-description h4{
		font-size: 18px;
		margin-bottom: 4px;
		font-weight: 500;
		color: #38383A;
	}

	.item-description h6{
		margin-top: 5px;
		font-size: 13px;
	}

	.item-description i{
		color: #18384D;
		margin-right: 5px;
	}

	.item-image{
		width: 100%;
		height: 160px;
		border-radius: 10px;
		overflow: hidden;
	}

	@supports(object-fit: cover){
    .item-image img{
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
	
	.restaurant-item{
		width: 46%;
		border: 1px solid #ddd;
		border-radius: 10px;
		padding: 10px;
		margin-right: 12px;
		margin-bottom: 15px;
		/*box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;*/
		box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
	}

	.collection-restaurant{
		width: 100%;
		height: auto;
		padding: 10px 0px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;	
	}

	.new-restaurant-container{
		width: 100%;
		height: auto;
		padding: 10px 15px;
	}

	.header-rest-tittle{
		width: 100%;
		height: auto;
		display: flex;
		padding: 10px 0px;
		justify-content: space-between;
		align-items: center;
	}

	.header-rest-tittle h4{
		margin-bottom: 0;
		font-size: 21px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
	}

	.header-rest-tittle h5{
		margin-bottom: 0;
		font-size: 15px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
	}

	.tittle-service{
		width: 100%;
		padding: 10px 15px;
		text-align: left;
	}

	.tittle-service h4{
		font-size: 21px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		margin-bottom: 0;
	}

	.father-icon-container{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}


	.service-description{
		width: 100%;
		background: #fff;
		border: 1px solid #ddd;
		border-radius: 10px;
		padding: 23px 10px;
		margin-top: -20px;
		text-align: center;
	}

	.service-description h4{
		font-size: 15px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		margin-bottom: 0;
	}

	#icon_0 img{
		width: 70%;
	}

	.icon-container{
		width: 55px;
		height: 55px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 532;
	}

	.icon-container img{
		width: 50%;
	}

	.single-service{
		width: 150px;
		margin-right: 10px;
    display: inline-block;
	}

	.services-container{
		width: 100%;
    padding-left:15px;
    padding-right: 15px;
    padding-bottom: 15px;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    border-bottom: 10px solid #F4F6FA;
	}

	.license-info-button{
		width: 45px;
		height: 45px;
		background: #F4F6FA;
		border-radius: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}

	.license-search-button{
		width: 45px;
		height: 45px;
		background: #F4F6FA;
		border-radius: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.first-info{
		width: 60%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.second-info{
		width: 40%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.meta-data-license{
		display: block;
		text-align: left;
	}

	.meta-data-license h5{
		color: #B0B0B0;
		font-size: 13px;
		font-weight: 500;	
	}

	.meta-data-license i{
		color: #DD353C;
		margin-right: 5px;
	}

	/*Fin nuevo css*/


	.new-all-container{
		width: 100%;
		display: block;
		height: auto;
		padding-bottom: 15px;
		border-bottom: 10px solid #F4F6FA;
	}

	.new-header-container{
		width: 100%;
		height: auto;
		padding: 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}

	.new-header-container h4{
		font-size: 20px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
	}

	.logo-cuadro{
		width: 45px;
		height: 45px;
		padding: 5px;
		border-radius: 4px;
		box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
		margin-right: 15px;	
	}

	.logo-cuadro img{
		width: 100%;
		height: auto;
	}

	.search-input{
		width: 93%;
		padding: 15px 20px;
		margin: 0 auto;
		border-radius: 13px;
		background: #F4F6FA;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.search-input i{
		font-size: 17px;
		color: #A6AAB3;
	}

	.search-input input{
		width: 90%;
		margin-left: 10px;
		font-size: 14px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		background: transparent;
		border: none;
	}


	.header-delivery-container{
		width: 100%;
		height: auto;
		padding: 15px;
		display: block;
		background: #fff;
	}

	.name-search-options{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 5px;
		margin-bottom: 8px;
	}

	.license-name{
		width: 90%;
		height: auto;
		text-align: left;
	}

	.search-options{
		width: 10%;
		text-align: right;
	}

	.license-name h4{
		font-size: 19px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
	}

	@supports(object-fit: cover){
        .portada img{
          height: 100%;
          object-fit: cover;
          object-position: center center;
        }
    }

    .portada img{
        width: 100%;
        height: auto;
    }

    .portada{
    	overflow: hidden;

    }

    .logo-container{
    	width: 100%;
    	height: auto;
    	display: flex;
    	justify-content: flex-end;
    	align-items: center;
    	padding-right: 26px;
    	margin-top:-55px;
    }

    .logo-license{
    	width: 85px;
    	height: 85px;
    	border-radius: 10px;
    	border: 5px solid #fff;
    	overflow: hidden;
    	background: #fff;
    	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    	z-index: 2;
    }

    .logo-license img{
    	width: 100%;
    	height: auto;
    }

    .license-data{
    	width: 100%;
    	text-align: left;
    	display: block;
    }

    .license-data h4{
    	margin-bottom: 5px;
    	font-size: 15px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
    }

    .license-data i{
    	color: #000;
    	margin-right: 5px;
    }

    .license-data-2{
    	width: 100%;
    	text-align: left;
    	display: block;
    	padding: 15px 17px;
    }

    .license-data-2 h4{
    	margin-bottom: 5px;
    	font-size: 15px;
			font-weight: 500;
			font-family: 'Poppins', sans-serif;
    }

    .license-data-2 i{
    	/*color: #DD353C;*/
    	margin-right: 5px;
    }

    .restaurant-collections{
    	width: 100%;
    	min-height: 60vh;
    	background: #F4F6FA;
    	padding: 30px 15px;
    	display: block;
    	text-align: center;		
    	border-top-left-radius: 20px;
    	border-top-right-radius: 20px;
    	box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
    }

    .header-title-restaurant{
    	width: 100%;
    	text-align: left;
    	padding-bottom: 10px;
    }

    .header-title-restaurant h4{
    	font-size: 20px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
    }


    .single-restaurant{
    	width: 100%;
    	height: auto;
    	border: 1px solid #ddd;
    	background: #fff;
    	padding-bottom: 10px;
    	margin-bottom: 15px;
    }

    .single-restaurant-banner{
    	width: 100%;
    	height: 120px;
    	overflow: hidden;
    }

    .single-restaurant-banner img{
    	width: 100%;
    	height: auto;
    }

    .single-restaurant-logo-name-container{
    	width: 100%;
    	height: auto;
    	background: #fff;
    	display: flex;
    	justify-content: space-between;
    	flex-wrap: wrap;
    }

    .single-restaurant-name{
    	width: 50%;
    	text-align: left;
    	padding: 10px;
    }

    .single-restaurant-name h4{
    	font-size: 19px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		margin-bottom: 0;
    }

    .single-restaurant-logo{
    	width: 50%;
    	display: flex;
    	justify-content: flex-end;
    	margin-top: -30px;
    	padding-right: 30px;
    }

    .second-logo-container{
    	width: 70px;
    	height: 70px;
    	background: #fff;
    	border-radius: 5px;
    	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    	display: flex;
    	justify-content: center;
    	align-items: center;
    }

    .second-logo-container img{
    	width: 80%;
    	height: auto;
    }

    .single-restaurant-info{
    	width: 100%;
    	background: #fff;
    	display: inline-block;
    	text-align: left;
    	padding: 5px 10px;
    }

    .single-restaurant-info h4{
    	display: inline-block;
    	font-size: 14px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		margin-bottom: 0;
    }

    .single-restaurant-info h4:nth-child(2){
    	margin-left: 10px;
    }

    .single-restaurant-info i{
    	margin-right: 5px;
    	color: #DD353C;
    }
</style>

<script>
	import MensajeriaCheckout from './MensajeriaCheckout.vue';
	import DeliveryCheckout from './DeliveryCheckout.vue'
	export default{
		props: ['delivery_data'],
		components: {
      MensajeriaCheckout,
      DeliveryCheckout
    },
		data(){
			return{
				status_view: false,
				contador: 0,
				contador2:0,
				status_info: true,
				status_search: false,
				url_images: "https://back.vinapp.co/",
				id: this.delivery_data.id_mensajeria,
				nombre: this.delivery_data.nombre,
				logo: this.delivery_data.logo,
				direccion: this.delivery_data.direccion,
				horario: this.delivery_data.horario,
				portada: this.delivery_data.portada,
				color_licencia: this.delivery_data.color,
				restaurantes: this.delivery_data.restaurantes,
				servicios: this.delivery_data.servicios,
				service_selected: "",
				valor_domicilio: this.delivery_data.domicilio
			}
		},
		methods:{
			openNewview(){
				this.status_view = true;
			},
			closeNewView(){
				this.status_view = false;
			},
			openCheckout(servicio){
				this.service_selected = servicio;
			},
			openSearch(){
				if (this.contador == 0) {
					this.status_search= true;
					$(".license-search-button .fa-angle-up").show();
					$(".fa-search").hide();
					this.contador++;
				}else{
					this.status_search= false;
					$(".license-search-button .fa-angle-up").hide();
					$(".fa-search").show();
					this.contador = 0;
				}	
			},
			openInfo(){
				if (this.contador2 == 0) {
					this.status_info= false;
					$(".license-info-button .fa-info").show();
					$(".fa-angle-up").hide();
					this.contador2++;
				}else{
					this.status_info= true;
					$(".license-info-button .fa-info").hide();
					$(".license-info-button .fa-angle-up").show();
					this.contador2 = 0;
				}
			},
			openDetail(restaurant){
				let redireccion = location.origin+"/"+restaurant.uri+"?delivery";
				localStorage.setItem('uri_delivery', location.pathname);
				localStorage.setItem('name_delivery', this.nombre);
				localStorage.setItem('delivery_cost', this.valor_domicilio);
				location.href = redireccion;
				localStorage.setItem('id_delivery', this.id);
			},
			search(){
	      var texto = document.getElementById('buscar').value;
	      var self = this;
	      if(texto.trim() != ""){
	        Object.values(self.restaurantes).forEach((item, index) =>{  
	          if(!item.name.trim().toUpperCase().includes(texto.trim().toUpperCase())){
	            document.getElementById("restaurant_"+index).style.display = "none";
	          }else{
	            document.getElementById("restaurant_"+index).style.display = "";
	          }
	        });
	      }else{
	        //cuando queda vacio el input search 
	        Object.values(self.restaurantes).forEach((item, index) =>{              
	       		document.getElementById("restaurant_"+index).style.display = "";
	        });
	      }
      },
      search2(){
	      var texto = document.getElementById('buscar2').value;
	      var self = this;
	      if(texto.trim() != ""){
	        Object.values(self.restaurantes).forEach((item, index) =>{  
	          if(!item.name.trim().toUpperCase().includes(texto.trim().toUpperCase())){
	            document.getElementById("view_"+index).style.display = "none";
	          }else{
	            document.getElementById("view_"+index).style.display = "";
	          }
	        });
	      }else{
	        //cuando queda vacio el input search 
	        Object.values(self.restaurantes).forEach((item, index) =>{              
	       		document.getElementById("view_"+index).style.display = "";
	        });
	      }
      }
		},
		mounted(){
			$(".license-search-button .fa-angle-up").hide();
			$(".license-info-button  .fa-info").hide();
			console.log(this.servicios);
			localStorage.setItem('id_delivery', this.id);
		}
	}
</script>